<template>
  <div>我的评论</div>
</template>

<script>
export default {
data() {
    const message=[
        {label:'系统通知',value:'0'},
        {label:'活动提醒',value:'1'},
        {label:'我的评论',value:'2'}]
    return {
        message
    }
},
}
</script>

<style>

</style>